import React, { useEffect, useState, useCallback } from "react";
import { MdClose } from "react-icons/md";
import server from "../../api/server.js";
import '../../dashboard-components/loader.css';
import { useToast } from '../../context/ToastContext.jsx';

const FeedbackLayout = ({client_id, service_id, call_id, anthro_id, manager_name, employee_name, close}) => {
    const { showToast } = useToast();
    const [feedback, setFeedback] = useState([]);
    const [recipients, setRecipients] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [reply, setReply] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [associatedEmails, setAssociatedEmails] = useState([])
    const getFeedbackData = async () => {
        try {
            setIsLoading(true);
            let res = await server.getFeedbackData(client_id, service_id, call_id, anthro_id, 'Calls', null);
            if(res.status === 200){
                setIsLoading(false);
                let resp = await res.json();
                if(resp.feedback && resp.associated_emails){
                    setFeedback(resp.feedback);
                    setAssociatedEmails(resp.associated_emails);
                }
            }
        } catch (error) {
            setIsLoading(false);
        }
    }
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => func(...args), delay);
        };
      };
      
      const debouncedGetFeedbackData = useCallback(debounce(getFeedbackData, 300), []);
    useEffect(()=>{
        const user = getCookie("dashboard_login_user_creds") ? JSON.parse(getCookie("dashboard_login_user_creds")) : null;
        if (user) {
        setUserEmail(user.email);
        }
        debouncedGetFeedbackData();
    }, [])
    const handleclose = () => {
        close(true);
    }
    const formatTime = (timestamp) => {
        const date = new Date(timestamp * 1000);
        return date.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };
    const handleInputKeyDown = (e) => {
        if (e.key === 'Enter' && inputValue.trim()) {
            setRecipients([...recipients, inputValue.trim()]);
            setInputValue('');
        }
    };

    const removeRecipient = (indexToRemove) => {
        setRecipients(recipients.filter((_, index) => index !== indexToRemove));
    };
    const handleResolve = () => {
        // Add resolve logic here
        let obj = {
            type: "resolved",
            mail_id: userEmail,
            added_emails: [],
            time: Math.floor(Date.now() / 1000)
        }
        const newFeedback = [...feedback, obj];
        setFeedback(newFeedback);
        handleSaveFeedback(obj);
        showToast("Marked as Resolved", "success");
    };

    const handleReopen = () => {
        // Add reopen logic here
        let obj = {
            type: "reopened",
            mail_id: userEmail,
            added_emails: [],
            time: Math.floor(Date.now() / 1000)
        }
        const newFeedback = [...feedback, obj];
        setFeedback(newFeedback);
        handleSaveFeedback(obj);
        showToast("Marked as Reopened", "success");
    };

    const getLatestStatus = () => {
        for (let i = feedback.length - 1; i >= 0; i--) {
            if (feedback[i].type === 'resolved' || feedback[i].type === 'reopened' || feedback[i].type === 'message') {
                return feedback[i].type;
            }
        }
        return '';
    };

    const renderActionButton = (latestStatus) => {
        if (latestStatus === 'resolved') {
            return (
                <button onClick={handleReopen} className="action-button reopen">
                    <span className="action-icon">↻</span>
                    Reopen
                </button>
            );
        } else if(latestStatus === 'reopened' || latestStatus === 'message'){
            return (
                <button onClick={handleResolve} className="action-button resolve">
                    <span className="action-icon">✓</span>
                    Resolve
                </button>
            );
        }
    };
    const handleReply = () => {
        let obj = {
            type: 'message',
            mail_id: userEmail,
            added_emails: recipients,
            time: Math.floor(Date.now() / 1000),
            message: reply
        }
        const newFeedback = [...feedback, obj];
        setFeedback(newFeedback);
        handleSaveFeedback(obj);
        showToast("Replied Successfully!", "success");
        setRecipients([])
        setReply('')
    }

    const handleSaveFeedback = async (feedback) => {
        try {
            let obj = {client_id, service_id, call_id, anthro_id, feedback, manager_name, employee_name, menu: 'Calls', subMenu: undefined};
            let res = await server.postFeedback(obj);
            if(res.status === 200){
                let resp = await res.json()
            }
        } catch (error) {
        }
    }

    const latestStatus = getLatestStatus();

    return (
        <div className="layout-container">
            <div style={{display: "flex", justifyContent: "space-between", background: "rgb(249, 250, 251)",borderRadius: "10px 10px 0 0px",height: "60px",alignItems: "center", borderBottom: "1px solid rgb(214, 214, 214)"}}>
                <div></div>
                <h1 style={{fontSize: "26px",textAlign: "center",width: "21%"}}>Feedback Thread</h1>
                <div style={{padding: "10px", float: "inline-end" }}>
                    <MdClose style={{cursor: "pointer"}} onClick={()=> close(true)}/>
                </div>
            </div>
            <div className="feedback-container">
            {
                isLoading && (
                <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                    <div className="loader"></div>
                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                </div>
                )
            }
            {
                !isLoading && feedback.length===0 && (
                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                        <img src="/dashboard/assets/paper.png" style={{height: "10vh"}} alt=""/>
                        <h2 style={{textAlign: "center", fontSize: "24px"}}>No Feedbacks Yet!</h2>
                    </div>
                )
            }
                { !isLoading && feedback.length>0 && (<div className="timeline">
                    <div className="timeline-line" />
                    {feedback.map((item, index) => (
                        <div key={index} className={`feedback-item ${item.type}`}>
                            <div className={`status-indicator ${item.type}`}>
                                {item.type === 'resolved' && '✓'}
                                {item.type === 'reopened' && '↻'}
                                {item.type === 'message' && '💬'}
                            </div>
                            
                            <div className={`feedback-content ${item.type}`}>
                                <div className="feedback-header">
                                    <div className="email">{item.mail_id}</div>
                                    <div className="timestamp">
                                        <span className="clock-icon">🕒</span>
                                        {formatTime(item.time)}
                                    </div>
                                </div>

                                {item.type === 'message' && item.message && (
                                    <p className="message">{item.message}</p>
                                )}
                                
                                {item.type === 'resolved' && (
                                    <p className="status-message">Marked as resolved</p>
                                )}
                                
                                {item.type === 'reopened' && (
                                    <p className="status-message">Ticket reopened</p>
                                )}

                                {item.added_emails && item.added_emails.length > 0 && (
                                    <div className="added-emails">
                                        <p className="email-label">Added emails:</p>
                                        <div className="email-tags">
                                            {item.added_emails.map((email, emailIndex) => (
                                                <span key={emailIndex} className="email-tag">
                                                    {email}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>)}
            </div>
            <div>
                {/* <ToastContainer/> */}
            </div>
            <div style={{background: "rgb(249, 250, 251)", borderTop: "1px solid rgb(214, 214, 214)", borderRadius: "0 0 10px 10px"}}>
            <div className="reply-container">
                <div className="reply-section">
                    <div className="recipients-input">
                        {recipients.map((recipient, index) => (
                            <div key={index} className="recipient-tag">
                                {recipient}
                                <button 
                                    className="remove-recipient" 
                                    onClick={() => removeRecipient(index)}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                        <input
                            type="text"
                            placeholder="Add email recipient (press Enter)"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleInputKeyDown}
                        />
                    </div>
                    <div className="reply-input">
                        <textarea class="global-input"placeholder="Write your reply..." value={reply} onChange={(e)=> setReply(e.target.value)} />
                        <div className="button-container">
                            <div>
                            {renderActionButton(latestStatus)}
                            </div>
                            <div style={{display: "flex", gap: "10px"}}>
                            <button onClick={handleclose} className="cancel-button">Cancel</button>
                            <button onClick={handleReply} className="reply-button">Reply</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{padding: "5px 10px"}}>
                        <p style={{color: "grey", fontSize: "12px", marginTop: "3px", fontStyle: "italic"}}>All associated & newly added emails will receive update notification via email.</p>
                        {
                            associatedEmails.length > 0 && (
                                <div style={{fontSize: "12px", fontWeight: "600", color: "grey", fontStyle: "italic"}}>
                                    Associated Emails: {
                                        associatedEmails.map((item, idx)=> {
                                            return (
                                                <span style={{fontWeight: "500"}}>{item}{idx !== associatedEmails.length-1 ? ", " : " "}</span>
                                            )
                                        })
                                    }
                                </div>
                            )
                        }
                    </div>
            </div>


            <style jsx>{`
            .action-button {
                    display: inline-flex;
                    align-items: center;
                    padding: 0.5rem 1rem;
                    border: none;
                    border-radius: 0.375rem;
                    font-weight: 500;
                    cursor: pointer;
                    margin-bottom: 1rem;
                }

                .action-button.resolve {
                    background-color: #64a82e; /* Dark green background */
                    color: #ffffff; /* White text for contrast */
                }

                .action-button.reopen {
                    background-color: #ffb63b; /* Darker yellow background */
                    color: black; /* Deep brownish-orange text for contrast */
                }

                .action-icon {
                    margin-right: 0.5rem;
                    font-size: 1rem;
                }
                .layout-container {
                    display: flex;
                    flex-direction: column;
                    height: 83vh;
                }

                .feedback-container {
                    width: 100%;
                    max-width: 100%;
                    margin: 0 auto;
                    padding: 1rem;
                    height: calc(83vh - 250px);
                    overflow-y: auto;
                }

                .timeline {
                    position: relative;
                }

                .timeline-line {
                    position: absolute;
                    left: 1rem;
                    top: 0;
                    bottom: 0;
                    width: 2px;
                    background-color: #e5e7eb;
                }

                .feedback-item {
                    position: relative;
                    margin-bottom: 2rem;
                    margin-left: 2rem;
                }

                .status-indicator {
                    position: absolute;
                    left: -1.8rem;
                    width: 1.5rem;
                    height: 1.5rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.875rem;
                }

                .status-indicator.resolved {
                    background-color: #ecfdf5;
                    color: #047857;
                }

                .status-indicator.reopened {
                    background-color: #fefce8;
                    color: #a16207;
                }

                .status-indicator.message {
                    background-color: #f9fafb;
                    color: #374151;
                }

                .feedback-content {
                    padding: 1rem;
                    border-radius: 0.5rem;
                }

                .feedback-content.resolved {
                    background-color: #ecfdf5;
                }

                .feedback-content.reopened {
                    background-color: #fefce8;
                }

                .feedback-content.message {
                    background-color: #f9fafb;
                }

                .feedback-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 0.5rem;
                }

                .email {
                    font-weight: 600;
                }

                .timestamp {
                    font-size: 0.875rem;
                    color: #6b7280;
                    display: flex;
                    align-items: center;
                }

                .clock-icon {
                    margin-right: 0.25rem;
                    font-size: 0.75rem;
                }

                .message {
                    color: #374151;
                    margin-bottom: 0.5rem;
                }

                .status-message {
                    font-weight: 500;
                }

                .status-message.resolved {
                    color: #31B6B6;
                }

                .status-message.reopened {
                    color: #a16207;
                }

                .added-emails {
                    margin-top: 0.5rem;
                    display: flex;
                    align-items: center;
                }

                .email-label {
                    font-size: 0.875rem;
                    color: #6b7280;
                    margin-right: 0.25rem;
                }

                .email-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                }

                .email-tag {
                    display: inline-flex;
                    align-items: center;
                    padding: 0.25rem 0.5rem;
                    background-color: white;
                    border-radius: 0.375rem;
                    font-size: 0.875rem;
                    color: #374151;
                }

                .reply-container {
                    background-color: rgb(249, 250, 251);
                    padding: 0.5rem 1rem 0 1rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .reply-section {
                    max-width: 60rem;
                    margin: 0 auto;
                    width: 60%;
                }

                .recipients-input {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                    padding: 0.5rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.375rem;
                    margin-bottom: 0.5rem;
                    background: white;
                }

                .recipient-tag {
                    display: inline-flex;
                    align-items: center;
                    padding: 0.25rem 0.5rem;
                    background-color: #f3f4f6;
                    border-radius: 0.375rem;
                    font-size: 0.875rem;
                    color: #374151;
                }

                .remove-recipient {
                    margin-left: 0.5rem;
                    font-size: 1rem;
                    color: #6b7280;
                    background: none;
                    border: none;
                    cursor: pointer;
                }

                .recipients-input input {
                    border: none;
                    outline: none;
                    flex-grow: 1;
                    min-width: 200px;
                    font-size: 0.875rem;
                }

                .reply-input {
                    display: flex;
                    flex-direction: column;
                }

                textarea {
                    width: 100%;
                    min-height: 100px;
                    padding: 0.5rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.375rem;
                    margin-bottom: 0.5rem;
                    resize: vertical;
                }

                .button-container {
                    display: flex;
                    justify-content: space-between;
                    gap: 1rem;
                }

                .cancel-button {
                    padding: 0.2rem 1rem;
                    border: none;
                    border-radius: 0.375rem;
                    background-color: white;
                    color: #374151;
                    font-weight: 500;
                    cursor: pointer;
                    border: 1px solid rgb(214, 214, 214);
                    height: 40px;
                }

                .reply-button {
                    padding: 0.2rem 1rem;
                    border: none;
                    border-radius: 0.375rem;
                    background-color: black;
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    height: 40px;
                }

            `}</style>
        </div>
    );
};

export default FeedbackLayout;